const initialState = {
  apiModalShow: false
};

export default initialState;
